import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, isRef as _isRef, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "user-menu__login-loader",
  role: "status"
}
const _hoisted_2 = { class: "user-menu__status user-menu__status--desktop" }
const _hoisted_3 = { class: "user-menu__status__time" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "user-menu__label",
  for: "userMenuBtn"
}
const _hoisted_6 = { class: "user-menu__status user-menu__status--mobile" }
const _hoisted_7 = { class: "user-menu__status__time" }
const _hoisted_8 = { class: "user-menu__user" }
const _hoisted_9 = { class: "user-menu__user-body" }
const _hoisted_10 = {
  class: "user-menu__name",
  id: "userName"
}
const _hoisted_11 = {
  key: 0,
  class: "user-menu__balance",
  id: "userBalance"
}
const _hoisted_12 = {
  key: 2,
  class: "user-menu__menu"
}
const _hoisted_13 = { class: "user-menu__list" }
const _hoisted_14 = { class: "user-menu__menu__item" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "user-menu__menu__item" }
const _hoisted_17 = { class: "user-menu__menu__item" }
const _hoisted_18 = { class: "user-menu__menu__item balance" }

import { ngAction } from "@sazka/ng/ng-integration";
import { computed, ref } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { navigateToSportBetsUrl } from "@/sports-bets/sports-bets-navigation";
import { registerUserMenuBtn } from "@/shared/components/master-page/main-menu";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { useAuthentication } from "@sazka/ng/authentication/composables/use-authentication";
import { useMountAuthentication } from "@sazka/ng/authentication/composables/use-mount-authentication";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { useHeader } from "./header";

const sportsBetsMyBetsPath = "/sports/bet-history";

export default /*@__PURE__*/_defineComponent({
  __name: 'user-menu',
  setup(__props) {

const { isLoggedIn, session, balance, showBalance, loginDurationFormatted, isSessionStateFromCacheReady } =
    useNgSession();

const isSportsBets = environment.nodeAliasPath?.startsWith("/kurzove-sazky");
const isCasino = environment.nodeAliasPath?.startsWith("/hry");
const showComponent = computed(() => isSessionStateFromCacheReady.value);
const showMenu = ref(false);

const showDeposit = isCasino || isSportsBets;
const showMyBets = !isCasino;
const myBetsLink = isSportsBets ? "/kurzove-sazky/sports/bet-history" : "/moje-sazky";

const userName = computed(() => session.value?.PlayerName);
const displayBalance = computed(() => balance.value?.DisplayBalance);

const navigateToSportsBetsHistory = () => navigateToSportBetsUrl(sportsBetsMyBetsPath);

const navigateToMyBets = () => {
    if (isSportsBets) {
        navigateToSportsBetsHistory();
    } else {
        window.location.href = myBetsLink;
    }
};

const isLoginLoading = ref(false);

const openLoginModal = async () => {
    const loaderTimeout = setTimeout(() => {
        isLoginLoading.value = true;
    }, 150);

    await useMountAuthentication(false);
    ngAction("showLogin");

    clearTimeout(loaderTimeout);
    isLoginLoading.value = false;
};

const logout = async () => {
    await useAuthentication().logout();
};

const { headerState } = useHeader();
const isButtonLight = computed(() => headerState.value.dark || headerState.value.active);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user-menu", { 'balance-active': _unref(showBalance) }]),
    id: "user-menu"
  }, [
    (!_unref(isLoggedIn))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            class: "user-menu__registration",
            href: "/registrace"
          }, " Vytvořit účet ", -1)),
          _createVNode(DsButton, {
            class: _normalizeClass(["user-menu__login", { 'user-menu__login--loading': isLoginLoading.value }]),
            type: "primary",
            size: "sm",
            onClick: openLoginModal,
            theme: isButtonLight.value ? 'light' : 'dark',
            "is-disabled": isLoginLoading.value
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createTextVNode(" Přihlásit ")),
              _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
                [_vShow, isLoginLoading.value]
              ])
            ]),
            _: 1,
            __: [6]
          }, 8, ["class", "theme", "is-disabled"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(isSportsBets))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                id: "myTickets",
                onClick: _withModifiers(navigateToSportsBetsHistory, ["prevent"]),
                class: "user-menu__tickets"
              }, [
                _createVNode(DsIcon, {
                  name: "ico-tickets",
                  width: 16,
                  height: 16
                }),
                _cache[8] || (_cache[8] = _createTextVNode(" Tikety "))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "user-menu__status__text" }, "Přihlášen ", -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(loginDurationFormatted)), 1)
          ]),
          showMyBets
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                id: "myWagers",
                class: "user-menu__wagers",
                href: _unref(myBetsLink),
                onClick: _withModifiers(navigateToMyBets, ["prevent"])
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "19",
                  height: "23",
                  stroke: "#fff",
                  fill: "none",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", { d: "M13.093 21.613l-9.826.042a1.5 1.5 0 0 1-1.503-1.489L1.722 5.97a1.5 1.5 0 0 1 1.49-1.503l9.825-.043a1.5 1.5 0 0 1 1.503 1.49l.042 14.195a1.5 1.5 0 0 1-1.489 1.503z" }),
                  _createElementVNode("path", {
                    d: "M5.317 4.458L5.3 2.295A1.5 1.5 0 0 1 6.779.793L16.605.75a1.5 1.5 0 0 1 1.502 1.49l.043 14.195a1.5 1.5 0 0 1-1.489 1.502l-2.106.01M5.112 8.463l6.03-.026m-6.027 3.8l6.03-.026",
                    "stroke-linecap": "round"
                  })
                ], -1),
                _createTextVNode(" Moje sázky ")
              ]), 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["user-menu__deposit", { permanent: _unref(showDeposit) }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(ngAction)('showDeposit')))
          }, _cache[11] || (_cache[11] = [
            _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#0a1065\" transform=\"translate(1 1)\"><path d=\"M2.52297089,23 C4.24779106,23.1429689 5.96734079,23.2144533 7.68162008,23.2144533 C10.253039,23.2144533 12.1218022,22.7610768 13.4509554,22.0603271 C14.7322396,21.3848145 15.5120817,20.4794259 15.9365381,19.5286989 C16.4361786,18.4095695 16.4433842,17.2276177 16.1963839,16.2838381 C15.7541341,14.5940169 14.0201394,12.5914683 10.9943999,10.2761922 L4.63063386,10.2144533 C2.46932105,11.8857063 0.981572043,13.4023495 0.167386845,14.7643829\" transform=\"matrix(-1 0 0 1 16.523 0)\"></path><path d=\"M6.01190704,6.21445328 L11.011907,6.21445328 C12.1164765,6.21445328 13.011907,7.10988378 13.011907,8.21445328 C13.011907,9.31902278 12.1164765,10.2144533 11.011907,10.2144533 L6.01190704,10.2144533 C4.90733754,10.2144533 4.01190704,9.31902278 4.01190704,8.21445328 C4.01190704,7.10988378 4.90733754,6.21445328 6.01190704,6.21445328 Z\"></path><path stroke-linejoin=\"round\" d=\"M5.73445387,6.21445328 L4.01190704,1.64318112 L6.81353597,1.64318112 C6.83966331,0.547727039 7.37460847,8.43769499e-15 8.41837146,8.43769499e-15 C9.46213446,8.43769499e-15 9.99331298,0.547727039 10.011907,1.64318112 L13.011907,1.64318112 L11.5038167,6.21445328 L5.73445387,6.21445328 Z\"></path><line x1=\"10.012\" x2=\"10.012\" y1=\"1.474\" y2=\"3.968\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></line><g stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(14 7)\"><path d=\"M1.25460192 14L7.74539808 14C8.15834863 14 8.32545989 14.0464128 8.48842285 14.1335664 8.65138581 14.2207199 8.7792801 14.3486142 8.86643365 14.5115771 8.95358719 14.6745401 9 14.8416514 9 15.2546019L9 15.7453981C9 16.1583486 8.95358719 16.3254599 8.86643365 16.4884229 8.7792801 16.6513858 8.65138581 16.7792801 8.48842285 16.8664336 8.32545989 16.9535872 8.15834863 17 7.74539808 17L1.25460192 17C.841651367 17 .674540111 16.9535872.511577148 16.8664336.348614185 16.7792801.220719898 16.6513858.133566352 16.4884229.0464128056 16.3254599 1.93921147e-17 16.1583486-3.11797421e-17 15.7453981L3.11797421e-17 15.2546019C-1.93921147e-17 14.8416514.0464128056 14.6745401.133566352 14.5115771.220719898 14.3486142.348614185 14.2207199.511577148 14.1335664.674540111 14.0464128.841651367 14 1.25460192 14zM2.25460192 11L8.74539808 11C9.15834863 11 9.32545989 11.0464128 9.48842285 11.1335664 9.65138581 11.2207199 9.7792801 11.3486142 9.86643365 11.5115771 9.95358719 11.6745401 10 11.8416514 10 12.2546019L10 12.7453981C10 13.1583486 9.95358719 13.3254599 9.86643365 13.4884229 9.7792801 13.6513858 9.65138581 13.7792801 9.48842285 13.8664336 9.32545989 13.9535872 9.15834863 14 8.74539808 14L2.25460192 14C1.84165137 14 1.67454011 13.9535872 1.51157715 13.8664336 1.34861419 13.7792801 1.2207199 13.6513858 1.13356635 13.4884229 1.04641281 13.3254599 1 13.1583486 1 12.7453981L1 12.2546019C1 11.8416514 1.04641281 11.6745401 1.13356635 11.5115771 1.2207199 11.3486142 1.34861419 11.2207199 1.51157715 11.1335664 1.67454011 11.0464128 1.84165137 11 2.25460192 11zM1.25460192 8L7.74539808 8C8.15834863 8 8.32545989 8.04641281 8.48842285 8.13356635 8.65138581 8.2207199 8.7792801 8.34861419 8.86643365 8.51157715 8.95358719 8.67454011 9 8.84165137 9 9.25460192L9 9.74539808C9 10.1583486 8.95358719 10.3254599 8.86643365 10.4884229 8.7792801 10.6513858 8.65138581 10.7792801 8.48842285 10.8664336 8.32545989 10.9535872 8.15834863 11 7.74539808 11L1.25460192 11C.841651367 11 .674540111 10.9535872.511577148 10.8664336.348614185 10.7792801.220719898 10.6513858.133566352 10.4884229.0464128056 10.3254599 1.93921147e-17 10.1583486-3.11797421e-17 9.74539808L3.11797421e-17 9.25460192C-1.93921147e-17 8.84165137.0464128056 8.67454011.133566352 8.51157715.220719898 8.34861419.348614185 8.2207199.511577148 8.13356635.674540111 8.04641281.841651367 8 1.25460192 8z\"></path><circle cx=\"5\" cy=\"4\" r=\"4\"></circle><path d=\"M5,6 C6.1045695,6 7,5.1045695 7,4\"></path></g></g></svg> Vklad ", 2)
          ]), 2),
          _withDirectives(_createElementVNode("input", {
            id: "userMenuBtn",
            type: "checkbox",
            class: "disable-default",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showMenu).value = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(registerUserMenuBtn) && _unref(registerUserMenuBtn)(...args)))
          }, null, 544), [
            [_vModelCheckbox, showMenu.value]
          ]),
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "user-menu__status__text" }, "Přihlášen ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(loginDurationFormatted)), 1)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "user-menu__user-icon" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "18",
                  height: "21",
                  stroke: "#fff",
                  fill: "none",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", { d: "M13.8 7.4c0 3.535-2.15 6.4-4.8 6.4s-4.8-2.865-4.8-6.4S6.35 1 9 1s4.8 2.866 4.8 6.4z" }),
                  _createElementVNode("path", {
                    d: "M12.936 14.262c2.236 0 4.064 1.764 4.064 3.92 0 .778-.66 1.413-1.465 1.413H2.465C1.66 19.596 1 18.96 1 18.182c0-2.156 1.83-3.92 4.064-3.92",
                    "stroke-linecap": "round"
                  })
                ])
              ], -1)),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(userName.value), 1),
                (_unref(showBalance))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(displayBalance.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_unref(isLoggedIn))
            ? _withDirectives((_openBlock(), _createElementBlock("nav", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("a", {
                      id: "userMenuWagers",
                      class: "user-menu__menu__link user-menu__menu__link--wagers",
                      href: _unref(myBetsLink),
                      onClick: _withModifiers(navigateToMyBets, ["prevent"])
                    }, "Moje sázky", 8, _hoisted_15)
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "user-menu__menu__link",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(ngAction)('showMyAccount')))
                    }, " Můj účet ")
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "user-menu__menu__link",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(ngAction)('showDeposit')))
                    }, " Vložit ")
                  ]),
                  _createElementVNode("li", { class: "user-menu__menu__item" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "user-menu__menu__link user-menu__menu__link--logout",
                      onClick: logout
                    }, " Odhlásit ")
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      class: "disable-default",
                      id: "toggleBalance",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showBalance) ? (showBalance).value = $event : null))
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showBalance)]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", {
                      class: "toggle-checkbox",
                      for: "toggleBalance"
                    }, [
                      _createElementVNode("span", { class: "toggle-checkbox__switch" }, [
                        _createElementVNode("span", { class: "toggle-checkbox__slider" })
                      ]),
                      _createElementVNode("span", { class: "toggle-checkbox__text" }, "Zobrazovat zůstatek")
                    ], -1))
                  ])
                ])
              ], 512)), [
                [_vShow, showMenu.value]
              ])
            : _createCommentVNode("", true)
        ], 64))
  ], 2)), [
    [_vShow, showComponent.value]
  ])
}
}

})